import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { ConstrainedField } from '@shared/models/constrained-field';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ValidationModel } from '@shared/models';
import { createConstrainedModel } from '../../dynamic-editor-base';

@Component({
  selector: 'app-dynamic-list',
  templateUrl: './dynamic-list.component.html',
  styleUrls: ['./dynamic-list.component.scss']
})
export class DynamicListComponent implements OnInit {
  @Input() public field!: ConstrainedField;
  @Input() public extraData!: DynamicListExtraData;

  public rowConstrainedFields: ConstrainedField[][] = [];

  ngOnInit() {
    if (this.extraData.data) {
      this.extraData.data.forEach(row => {
        this.addNewRow(row);
      })
    }
  }

  addNewRow(data?: any) {
    let mainFormArray = this.field.control as FormArray;
    let newFormGroup = this.createRowControls(data);
    mainFormArray.push(newFormGroup);
  }

  deleteRow(idx: number) {
    let mainFormArray = this.field.control as FormArray;
    mainFormArray.removeAt(idx);
    this.rowConstrainedFields.splice(idx, 1);

    mainFormArray.updateValueAndValidity();
  }

  createRowControls(data?: any): FormGroup {
    let sortVM: ValidationModel = {
      field: "sort",
      fType: "numeric",
      fHide: true,
      fEditable: true,
      fMandatory: false,
    }

    let sort = this.rowConstrainedFields.length;
    data = data ? { ...data, sort } : { sort };

    let rowControls: Record<string, AbstractControl> = {};
    let constrainedFields: ConstrainedField[] = createConstrainedModel([sortVM, ...this.extraData.validationModel], data);

    constrainedFields.forEach(cf => {
      rowControls[cf.key] = cf.control;
    });

    this.rowConstrainedFields.push(constrainedFields.filter(cf => !cf.hidden));
    return new FormGroup(rowControls);
  }

  drop(event: CdkDragDrop<ConstrainedField[]>) {
    moveItemInArray(this.rowConstrainedFields, event.previousIndex, event.currentIndex);
    moveItemInArray((this.field.control as FormArray).controls, event.previousIndex, event.currentIndex);
    (this.field.control as FormArray).controls.forEach((control: FormGroup, idx) => {
      control.get('sort').setValue(idx);
    })
  }
}

export interface DynamicListExtraData {
  data?: any;
  validationModel: ValidationModel[];
}
